import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserContext } from 'src/app/core/models/user/user-context.model';
import { UserContextService } from 'src/services/user-context.service';

@Injectable({
    providedIn: 'root',
})
export class UserContextResolverService implements Resolve<UserContext> {
    constructor(
        private router: Router,
        private userContextService: UserContextService
    ) {}

    resolve(): Observable<UserContext> | Observable<never> {
        return this.userContextService.loadUserContextAsObservable().pipe(
            catchError(() => {
                this.router.navigate(['/error']);
                return EMPTY;
            })
        );
    }
}
